import React from "react";
import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { SITE_URL } from "@/components/Seo";

// Clickable breadcrumb trail + matching BreadcrumbList JSON-LD (E-E-A-T signal).
// items: [{ label, to }] — the last item is the current page (no link).
export const Breadcrumbs = ({ items }) => {
  if (!items || items.length < 2) return null;
  const ld = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: items.map((it, i) => ({
      "@type": "ListItem",
      position: i + 1,
      name: it.label,
      ...(it.to ? { item: it.to === "/" ? `${SITE_URL}/` : `${SITE_URL}${it.to}` } : {}),
    })),
  };
  return (
    <nav aria-label="Fil d'Ariane" data-testid="breadcrumbs" className="bg-nj-bg border-b border-nj-olive">
      <ol className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 flex flex-wrap items-center gap-x-1.5 gap-y-1 text-sm text-nj-muted">
        {items.map((it, i) => {
          const last = i === items.length - 1;
          return (
            <li key={i} className="flex items-center gap-x-1.5">
              {i > 0 && <ChevronRight className="w-3.5 h-3.5 text-nj-muted/60 shrink-0" />}
              {last || !it.to ? (
                <span aria-current="page" className="text-nj-text font-medium" data-testid={`breadcrumb-current`}>{it.label}</span>
              ) : (
                <Link to={it.to} data-testid={`breadcrumb-link-${i}`} className="hover:text-nj-primary transition-colors">{it.label}</Link>
              )}
            </li>
          );
        })}
      </ol>
      <script type="application/ld+json">{JSON.stringify(ld)}</script>
    </nav>
  );
};

export default Breadcrumbs;
